<template>
  <div>
    <div class="p-5 bg-white rounded non-print">
      <div class="py-6 text-xl text-center">{{ $t('edit_history') }}</div>
      <between-date @onClick="initData"></between-date>
      <div class="flex justify-end py-3">
        <v-btn class="blue white--text mx-1" @click="exportExcel">
          <v-icon left>mdi-file-excel</v-icon>Export Excel
        </v-btn>
        <v-btn class="blue white--text mx-1" @click="printPDF">
          <v-icon left>mdi-file-excel</v-icon>{{ $t('print_pdf') }}
        </v-btn>
        <FilterColumnDataTable v-model="headers" @onSuccess="onSelectFilterColumn" dataTableName="ReportAudit" />
      </div>
      <div>
        <v-data-table
          v-if="dataTable"
          :headers="dataTable.headers"
          :items="dataTable.data"
          :items-per-page="itemsPerPage"
          class="elevation-1 v-data-table-report"
          item-key="objectId"
          v-model="selectedContracts"
          :show-select="isShowSelectContract"
          :single-select="false"
          :loading="isLoading"
          id="printarea"
          :no-data-text="$t('noinfo')"
          :no-results-text="$t('no_matching_records_found')">

          <template v-slot:item.createdAt="{ item }">
            <div>{{ $moment(item.createdAt).format("D/MM/YYYY, HH:mm ") }}</div>
          </template>
          <template v-slot:item.createdBy="{ item }">
            <div>{{ item.createdBy.firstName }} {{ item.createdBy.lastName }}</div>
          </template>
          <template v-slot:item.detail="{ item }">
            {{ item.detail }}
          </template>
          <template v-slot:item.showDetail="{ item }">
            <!-- <template v-if="item.type == 'send_invoice' || item.type == 'unsend_invoice' || item.type == 'pay_receipt'">
              เลขที่ : {{ item.newData.documentId }}
            </template> -->
            <template v-if="item.type == 'update_invoice' ||
              item.type == 'renew_contract' ||
              item.type == 'change_customer_contract' ||
              item.type == 'create_contract_document' ||
              item.type == 'update_contract_document' ||
              item.type == 'remove_contract_document' ||
              item.type == 'add_contract_area' ||
              item.type == 'update_contract' ||
              item.type == 'remove_contract_area' ||
              item.type == 'change_name_project' ||
              item.type == 'change_name_market' ||
              item.type == 'edit_area_product'">
              <a @click="showDetail(item)">{{ $t('view_detail') }}</a>
            </template>
            <!-- <template v-if="item.type == 'add_contract_area'">
              เพิ่มแผง {{ item.newData.contractArea.area.name }} ในสัญญา {{ item.newData.contract.contractId }}
            </template>
            <template v-if="item.type == 'remove_contract_area'">
              ลบแผง {{ item.newData.contractArea.area.name }} ในสัญญา {{ item.newData.contract.contractId }}
            </template> -->
            <!-- <template v-if="item.type == 'close_contract'">
              เลขที่สัญญา {{ item.newData.contractId }}
            </template> -->
          </template>
        </v-data-table>
      </div>
    </div>
    <v-dialog v-model="isAuditLogDetailDialog" scrollable :max-width="tempAuditLog.type == 'renew_contract' ? '500' :
      tempAuditLog.type == 'create_contract_document' ? '500' :
        tempAuditLog.type == 'add_contract_area' ? '500' :
          tempAuditLog.type == 'remove_contract_area' ? '500' :
            tempAuditLog.type == 'update_invoice' ? '1800' :
              tempAuditLog.type == 'change_customer_contract' ? '500' : '800'
      " v-if="tempAuditLog">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center blue white--text py-2">
          <span>{{ $t('detail') }}</span>
        </v-card-title>
        <v-card-text class="py-5" v-if="tempAuditLog.type == 'add_contract_area'">
          <p><b>{{ $t('contract.contract_number_only') }} : </b> {{ tempAuditLog.newData.contract.contractId }}</p>
          <p><b>{{ $t('area.space') }} : </b> {{ tempAuditLog.newData.contractArea.area.name }}</p>
        </v-card-text>
        <v-card-text class="py-5" v-if="tempAuditLog.type == 'remove_contract_area'">
          <p><b>{{ $t('contract.contract_number_only') }} : </b> {{ tempAuditLog.newData.contract.contractId }}</p>
          <p><b>{{ $t('area.space') }} : </b> {{ tempAuditLog.newData.contractArea.area.name }}</p>
        </v-card-text>
        <v-card-text class="py-5" v-if="tempAuditLog.type == 'renew_contract'">
          <p><b>{{ $t('contract.old_contract_number') }} : </b> {{ tempAuditLog.oldData.contractId }}</p>
          <p><b>{{ $t('contract.new_contract_number') }} : </b> {{ tempAuditLog.newData.contractId }}</p>
          <p><b>{{ $t('contract.start_date') }} : </b> {{ $moment(tempAuditLog.newData.startDate.iso).format("D/MM/YYYY") }}</p>
          <p><b>{{ $t('contract.end_date') }} : </b> {{ $moment(tempAuditLog.newData.endDate.iso).format("D/MM/YYYY") }}</p>
        </v-card-text>
        <v-card-text class="py-5" v-if="tempAuditLog.type == 'change_customer_contract'">
          <p><b>{{ $t('contract.contract_number_only') }} : </b> {{ tempAuditLog.newData.contractId }}</p>
          <p><b>{{ $t('payment.transferor') }} : </b> {{ tempAuditLog.oldData.billingData.name }}</p>
          <p><b>{{ $t('payment.transferee') }} : </b> {{ tempAuditLog.newData.billingData.name }}</p>
        </v-card-text>
        <v-card-text class="py-5"
          v-if="tempAuditLog.type == 'create_contract_document' || tempAuditLog.type == 'remove_contract_document'">
          <p><b>{{ $t('contract.contract_number_only') }} : </b> {{ tempAuditLog.newData.contract.contractId }}</p>
          <template
            v-if="(tempAuditLog.newData.files && tempAuditLog.newData.files.length) || (tempAuditLog.newData.templates && tempAuditLog.newData.templates.length)">
            <p><b>{{ $t('document_file') }}</b></p>
            <ul>
              <li v-for="file in tempAuditLog.newData.files" :key="file">{{ file.name }}</li>
            </ul>
            <ul>
              <li v-for="template in tempAuditLog.newData.templates" :key="template">{{ template.title }}</li>
            </ul>
          </template>
        </v-card-text>
        <v-card-text class="py-3" v-if="tempAuditLog.type == 'update_contract_document'">
          <v-row>
            <v-col cols="6">
              <v-card>
                <v-card-text>
                  <h4 class="text-center">{{ $t('old_data') }}</h4>
                  <p><b>{{ $t('contract.contract_number_only') }} : </b> {{ tempAuditLog.oldData.contract.contractId }}</p>
                  <template
                    v-if="(tempAuditLog.oldData.files && tempAuditLog.oldData.files.length) || (tempAuditLog.oldData.templates && tempAuditLog.oldData.templates.length)">
                    <p><b>{{ $t('document_file') }}</b></p>
                    <ul>
                      <li v-for="file in tempAuditLog.oldData.files" :key="file">{{ file.name }}</li>
                    </ul>
                    <ul>
                      <li v-for="template in tempAuditLog.oldData.templates" :key="template">{{ template.title }}</li>
                    </ul>
                  </template>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="6">
              <v-card>
                <v-card-text>
                  <h4 class="text-center">{{ $t('new_data') }}</h4>
                  <p><b>{{ $t('contract.contract_number_only') }} : </b> {{ tempAuditLog.newData.contract.contractId }}</p>
                  <template
                    v-if="(tempAuditLog.newData.files && tempAuditLog.newData.files.length) || (tempAuditLog.newData.templates && tempAuditLog.newData.templates.length)">
                    <p><b>{{ $t('document_file') }}</b></p>
                    <ul>
                      <li v-for="file in tempAuditLog.newData.files" :key="file">{{ file.name }}</li>
                    </ul>
                    <ul>
                      <li v-for="template in tempAuditLog.newData.templates" :key="template">{{ template.title }}</li>
                    </ul>
                  </template>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text class="py-3" v-if="tempAuditLog.type == 'update_invoice'">
          <v-row>
            <v-col cols="6">
              <v-card>
                <v-card-text>
                  <h4 class="text-center">{{ $t('old_data') }}</h4>
                  <template v-for="[key, value] in Object.entries(tempAuditLog.oldObject)">
                    <p :key="key" v-if="key != 'invoiceId'">
                      <template v-if="key == 'date'">
                        <b>{{ $t('date') }} : </b>{{ value ? $moment(value).format("D/MM/YYYY") : "-" }}
                      </template>
                      <template v-if="key == 'dueDate'">
                        <b>{{ $t('invoice.installment_due_date') }} : </b>{{ value ? $moment(value).format("D/MM/YYYY") : "-" }}
                      </template>
                      <template v-if="key == 'customerData'">
                        <p v-if="value.name">
                          <b>{{ $t('name') }} : </b>{{ value.name }}
                        </p>
                        <p v-if="value.address">
                          <b>{{ $t('project.address') }} : </b>{{ value.address }}
                        </p>
                        <p v-if="value.taxId">
                          <b>{{ $t('tax.tax_id_number') }} : </b>{{ value.taxId }}
                        </p>
                        <p v-if="value.branchName">
                          <b>{{ $t('address.company_branch') }} : </b>{{ value.branchName }}
                        </p>
                        <p v-if="value.tel">
                          <b>{{ $t('account.phone_number') }} : </b>{{ value.tel }}
                        </p>
                        <p v-if="value.email">
                          <b>Email : </b>{{ value.email }}
                        </p>
                      </template>
                      <template v-if="key == 'isVatInclusive'">
                        <b>{{ $t('product.product_price') }} : </b>{{ value ? $t('payment.price_vat_inclusive') : $t('payment.price_vat_exclusive') }}
                      </template>
                      <template v-if="key == 'items'">
                        <p><b>{{ $t('list') }}</b></p>
                        <v-simple-table>
                          <thead class="table-item header rounded-2">
                            <tr>
                              <th>{{ $t('list') }}</th>
                              <th>{{ $t('area.space') }}</th>
                              <th>{{ $t('product.quantity') }}</th>
                              <th>{{ $t('unit') }}</th>
                              <th>{{ $t('product.unit_price') }}</th>
                              <th>{{ $t('product.discount_unit') }}</th>
                              <th>{{ $t('tax.title') }}</th>
                              <th>{{ $t('product.withholding') }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="item, index in value" :key="index">
                              <td>{{ item.accountingProduct.name }}</td>
                              <td>{{ item.area ? item.area.name : "-" }}</td>
                              <td>{{ item.quantity || 0 }}</td>
                              <td>{{ item.unit }}</td>
                              <td class="text-right">{{ item.originalPricePerUnit | currency }}</td>
                              <td class="text-right">{{ item.discountPerUnit | currency }}</td>
                              <td class="text-center">{{ item.sellVatType == 1 ? `${$globalVatPercent}%` :
                                item.sellVatType == 2 ? "0%" :
                                $t('except') }}</td>
                              <td class="text-center">{{ item.whtPercent ? item.whtPercent + "%" : $t('no') }}</td>
                            </tr>
                          </tbody>
                        </v-simple-table>
                      </template>
                      <template v-if="key == 'totalValue'">
                        <b>{{ $t('market.total_value') }} : </b>{{ value | currency }}
                      </template>
                    </p>
                  </template>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="6">
              <v-card>
                <v-card-text>
                  <h4 class="text-center">{{ $t('new_data') }}</h4>
                  <template v-for="[key, value] in Object.entries(tempAuditLog.newObject)">
                    <p :key="key" v-if="key != 'invoiceId'">
                      <template v-if="key == 'date'">
                        <b>{{ $t('date') }} : </b>{{ value ? $moment(value).format("D/MM/YYYY") : "-" }}
                      </template>
                      <template v-if="key == 'dueDate'">
                        <b>{{ $t('invoice.installment_due_date') }} : </b>{{ value ? $moment(value).format("D/MM/YYYY") : "-" }}
                      </template>
                      <template v-if="key == 'customerData'">
                        <p v-if="value.name">
                          <b>{{ $t('name') }} : </b>{{ value.name }}
                        </p>
                        <p v-if="value.address">
                          <b>{{ $t('project.address') }} : </b>{{ value.address }}
                        </p>
                        <p v-if="value.taxId">
                          <b>{{ $t('tax.tax_id_number') }} : </b>{{ value.taxId }}
                        </p>
                        <p v-if="value.branchName">
                          <b>{{ $t('address.company_branch') }} : </b>{{ value.branchName }}
                        </p>
                        <p v-if="value.tel">
                          <b>{{ $t('account.phone_number') }} : </b>{{ value.tel }}
                        </p>
                        <p v-if="value.email">
                          <b>Email : </b>{{ value.email }}
                        </p>
                      </template>
                      <template v-if="key == 'isVatInclusive'">
                        <b>{{ $t('product.product_price') }} : </b>{{ value ? $t('payment.price_vat_inclusive') : $t('payment.price_vat_exclusive') }}
                      </template>
                      <template v-if="key == 'items'">
                        <p><b>{{ $t('list') }}</b></p>
                        <v-simple-table>
                          <thead class="table-item header rounded-2">
                            <tr>
                              <th>{{ $t('list') }}</th>
                              <th>{{ $t('area.space') }}</th>
                              <th>{{ $t('product.quantity') }}</th>
                              <th>{{ $t('unit') }}</th>
                              <th>{{ $t('product.unit_price') }}</th>
                              <th>{{ $t('product.discount_unit') }}</th>
                              <th>{{ $t('tax.title') }}</th>
                              <th>{{ $t('product.withholding') }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="item, index in value" :key="index">
                              <td>{{ item.accountingProduct.name }}</td>
                              <td>{{ item.area ? item.area.name : "-" }}</td>
                              <td>{{ item.quantity || 0 }}</td>
                              <td>{{ item.unit }}</td>
                              <td class="text-right">{{ item.originalPricePerUnit | currency }}</td>
                              <td class="text-right">{{ item.discountPerUnit | currency }}</td>
                              <td class="text-center">{{ item.sellVatType == 1 ? `${$globalVatPercent}%` :
                                item.sellVatType == 2 ? "0%" : $t('except') }}</td>
                              <td class="text-center">{{ item.whtPercent ? item.whtPercent + "%" : $t('no') }}</td>
                            </tr>
                          </tbody>
                        </v-simple-table>
                      </template>
                      <template v-if="key == 'totalValue'">
                        <b>{{ $t('market.total_value') }} : </b>{{ value | currency }}
                      </template>
                    </p>
                  </template>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-text class="py-3" v-if="tempAuditLog.type == 'update_contract'">
          <v-row v-if="!isLoadingDialog">
            <v-col cols="6">
              <v-card>
                <v-card-text>
                  <h4 class="text-center">{{ $t('old_data') }}</h4>
                  <template v-if="Object.keys(tempAuditLog.oldObject).length">
                    <template v-for="[key, value] in Object.entries(tempAuditLog.oldObject)">
                      <p :key="key">
                        <template v-if="key == 'businessName'">
                          <b>{{ $t('contract.business_name') }} : </b>{{ value }}
                        </template>
                        <template v-if="key == 'stallType'">
                          <b>{{ $t('market.rent_type') }} : </b>{{ value == 'regularly' ? $t('contact.stall_type.regularly') : $t('contact.stall_type.temporary') }}
                        </template>
                        <template v-if="key == 'startDate'">
                          <b>{{ $t('contract.start_date') }} : </b>{{ $moment(value).format("D/MM/YYYY") }}
                        </template>
                        <template v-if="key == 'endDate'">
                          <b>{{ $t('contract.end_date') }} : </b>{{ $moment(value).format("D/MM/YYYY") }}
                        </template>
                        <template v-if="key == 'contractDays'">
                          <b>{{ $t('invoice.installment_due_date') }} : </b>{{ value }}
                        </template>
                        <template v-if="key == 'billingData'">
                          <p v-if="value.name">
                            <b>{{ $t('name') }} : </b>{{ value.name }}
                          </p>
                          <p v-if="value.address">
                            <b>{{ $t('project.address') }} : </b>{{ value.address }}
                          </p>
                          <p v-if="value.taxId">
                            <b>{{ $t('tax.tax_id_number') }} : </b>{{ value.taxId }}
                          </p>
                          <p v-if="value.branchName">
                            <b>{{ $t('address.company_branch') }} : </b>{{ value.branchName }}
                          </p>
                          <p v-if="value.tel">
                            <b>{{ $t('account.phone_number') }} : </b>{{ value.tel }}
                          </p>
                          <p v-if="value.email">
                            <b>Email : </b>{{ value.email }}
                          </p>
                        </template>
                        <template v-if="key == 'startMeterData'">
                          <p v-if="value">
                            <b>{{ $t('meter.first_meter') }}</b>
                          <ul>
                            <li v-for="[meterId, data] in Object.entries(value)" :key="meterId">
                              {{ $t('area.space') }} <b>{{ getMeter(meterId).area.name }} </b>
                              {{ $t('meter.meter_name') }} <b>{{ getMeter(meterId).isMain ? $t('main') : getMeter(meterId).name }} ({{
                                getMeter(meterId).type == 'elec' ? $t('electricity') : $t('water') }})</b>
                              {{ $t('unit') }} <b>{{ data.unit || 0 }} </b>
                            </li>
                          </ul>
                      </p>
                    </template>
                    </p>
                  </template>
</template>
<template v-else>
  <p class="text-center mt-4">{{ $t('noinfo') }}</p>
</template>
</v-card-text>
</v-card>
</v-col>
<v-col cols="6">
  <v-card>
    <v-card-text>
      <h4 class="text-center">{{ $t('new_data') }}</h4>
      <template v-if="Object.keys(tempAuditLog.newObject).length">
        <template v-for="[key, value] in Object.entries(tempAuditLog.newObject)">
          <p :key="key" v-if="tempAuditLog.newObject">
            <template v-if="key == 'businessName'">
              <b>{{ $t('contract.business_name') }} : </b>{{ value }}
            </template>
            <template v-if="key == 'stallType'">
              <b>{{ $t('market.rent_type') }} : </b>{{ value == 'regularly' ? $t('contact.stall_type.regularly') : $t('contact.stall_type.temporary') }}
            </template>
            <template v-if="key == 'startDate'">
              <b>{{ $t('contract.start_date') }} : </b>{{ $moment(value).format("D/MM/YYYY") }}
            </template>
            <template v-if="key == 'endDate'">
              <b>{{ $t('contract.end_date') }} : </b>{{ $moment(value).format("D/MM/YYYY") }}
            </template>
            <template v-if="key == 'contractDays'">
              <b>{{ $t('invoice.installment_due_date') }} : </b>{{ value }}
            </template>
            <template v-if="key == 'billingData'">
              <p v-if="value.name">
                <b>{{ $t('name') }} : </b>{{ value.name }}
              </p>
              <p v-if="value.address">
                <b>{{ $t('project.address') }} : </b>{{ value.address }}
              </p>
              <p v-if="value.taxId">
                <b>{{ $t('tax.tax_id_number') }} : </b>{{ value.taxId }}
              </p>
              <p v-if="value.branchName">
                <b>{{ $t('address.company_branch') }} : </b>{{ value.branchName }}
              </p>
              <p v-if="value.tel">
                <b>{{ $t('account.phone_number') }} : </b>{{ value.tel }}
              </p>
              <p v-if="value.email">
                <b>Email : </b>{{ value.email }}
              </p>
            </template>
            <template v-if="key == 'startMeterData'">
              <p v-if="value">
                <b>{{ $t('meter.first_meter') }}</b>
              <ul>
                <li v-for="[meterId, data] in Object.entries(value)" :key="meterId">
                  {{ $t('area.space') }} <b>{{ getMeter(meterId).area.name }} </b>
                  {{ $t('meter.meter_name') }} <b>{{ getMeter(meterId).isMain ? $t('main') : getMeter(meterId).name }} ({{
                    getMeter(meterId).type == 'elec' ? $t('electricity') : $t('water') }})</b>
                  {{ $t('unit') }} <b>{{ data.unit || 0 }} </b>
                </li>
              </ul>
          </p>
        </template>
        </p>
      </template>
      </template>
      <template v-else>
        <p class="text-center mt-4">{{ $t('noinfo') }}</p>
      </template>

    </v-card-text>
  </v-card>
</v-col>
</v-row>
<v-card v-show="isLoadingDialog" min-height="100" elevation="0">
  <v-overlay absolute color="white" opacity="1">
    <v-progress-circular color="green" size="40" indeterminate></v-progress-circular>
  </v-overlay>
</v-card>
</v-card-text>

<v-card-text class="py-5" v-if="tempAuditLog.type == 'change_name_project'">
  <div class="p-2"><b>{{ $t('project.old_project_name') }} : </b> {{ tempAuditLog.oldData.name }}</div>
  <div class="p-2"><b>{{ $t('project.new_project_name') }} : </b> {{ tempAuditLog.newData.name }}</div>
</v-card-text>
<v-card-text class="py-5" v-if="tempAuditLog.type == 'change_name_market'">
  <div class="p-2"><b>{{ $t('project.old_market_name') }} : </b> {{ tempAuditLog.oldData.name }}</div>
  <div class="p-2"><b>{{ $t('project.new_market_name') }} : </b> {{ tempAuditLog.newData.name }}</div>
</v-card-text>

<v-card-text class="py-3" v-if="tempAuditLog.type == 'edit_area_product'">
  <v-row>
    <v-col cols="6">
      <v-card>
        <v-card-text>
          <h4 class="text-center">{{ $t('old_data') }}</h4>
          <p><b>{{ $t('area.space') }} : </b> {{ tempAuditLog.oldData.name }}</p>
          <p><b>{{ $t('product.title') }} : </b>
            <span v-if="tempAuditLog.oldData.products">{{ getProductName(tempAuditLog.oldData.products) }}</span>
          </p>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="6">
      <v-card>
        <v-card-text>
          <h4 class="text-center">{{ $t('new_data') }}</h4>
          <p><b>{{ $t('area.space') }} : </b> {{ tempAuditLog.newData.name }}</p>
          <p><b>{{ $t('product.title') }} : </b>
            <span v-if="tempAuditLog.newData.products">{{ getProductName(tempAuditLog.newData.products) }}</span>
          </p>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</v-card-text>
</v-card>
</v-dialog>
</div>
</template>

<script>
import BetweenDate from "./BetweenDate.vue";
import { AuditLog, Meter } from "../classes"
import DocumentEditorDialog from "../components/DocumentEditorDialog.component.vue"
import FilterColumnDataTable from "../components/FilterColumnDataTable.vue"
import { ExportAuditLog } from "../exports";
export default {
  components: {
    BetweenDate,
    DocumentEditorDialog,
    FilterColumnDataTable
  },
  computed: {
    admin() {
      return this.$store.getters["admin/getByMarketId"](this.marketId);
    },
    employee() {
      return this.$store.getters["employee/getByMarketId"](this.marketId);
    },
    userFullName() {
      return this.$store.getters["user/getFullName"];
    },
    dataTable() {
      return {
        headers: this.headers && this.headers.length ? this.headers.filter(h => h.isShow) : [], // filter(h=>h.isShow == true)
        data: this.auditLogs || []
      }
    }
  },
  data() {
    return {
      projectId: this.$route.params.projectId,
      marketId: this.$route.params.marketId,
      isLoading: false,
      auditLogs: null,
      isShowSelectContract: false,
      selectedContracts: [],
      project: null,
      market: null,
      templates: null,
      isContractTemplateDialog: false,
      startDate: this.$moment()
        .startOf("month")
        .format("YYYY-MM-DD"),
      endDate: this.$moment()
        .endOf("month")
        .format("YYYY-MM-DD"),
      itemsPerPage: 10,
      isAuditLogDetailDialog: false,
      tempAuditLog: null,
      isLoadingDialog: false,
      meters: null,
      headers: []
    };
  },
  created() {
    if (this.admin) {
      this.project = this.admin.project;
      this.market = this.admin.market;
    }
    if (this.employee) {
      this.project = this.employee.project;
      this.market = this.employee.market;
    }
    
    this.headers = [
        {
          text: this.$t('date'),
          value: "createdAt",
          align: "center",
          width: "200px"
        },
        {
          text: this.$t('type'),
          value: "typeString",
          align: "center",
          width: "200px"
        },
        {
          text: this.$t('customer.edit_data'),
          value: "detail",
          align: "center",
          width: "300px"
        },
        {
          text: this.$t('by'),
          value: "createdBy",
          align: "center",
          width: "300px"
        },
        {
          text: this.$t('detail'),
          value: "showDetail",
          align: "center",
          class: "non-print",
          cellClass: "non-print"
        },
    ];
  },
  mounted() {
    this.intiDataTable()
    this.initData()
  },
  methods: {
    intiDataTable() {
      if (this.headers && this.headers.length) {
        for (let header of this.headers) {
          if (header.isShow === undefined) header.isShow = true
          else header.isShow = false
        }
      }
      this.onSelectFilterColumn(this.headers.filter(h => h.isShow).map(h => h.value))
    },
    onSelectFilterColumn(hs) {
      let resHeaders = []
      let hst = []
      let filterDataTable = localStorage.getItem("filterDataTable");
      filterDataTable = filterDataTable ? JSON.parse(filterDataTable) : null
      let lhs = filterDataTable && filterDataTable['ReportAudit'] ? filterDataTable['ReportAudit'] : null
      if (lhs && lhs.length) hst = lhs
      else if (hs) hst = hs
      for (let header of this.headers) {
        header.isShow = hst.find(h => h == header.value) ? true : false;
        resHeaders.push(header)
      }
      this.headers = resHeaders
    },
    async initData(date) {
      this.isLoading = true
      try {
        this.auditLogs = await AuditLog.getAuditLogBetweenDateByMarket({
          marketId: this.marketId,
          startDate: date ? date.startDate : this.$moment(this.startDate).startOf("day").toISOString(),
          endDate: date ? date.endDate : this.$moment(this.endDate).endOf("day").toISOString()
        })
        if(date){
          this.startDate = this.$moment(date.startDate).format("YYYY-MM-DD")
          this.endDate = this.$moment(date.endDate).format("YYYY-MM-DD")
        }
        this.isLoading = false
      } catch (err) {
        this.isLoading = false
        this.$toast.show({
          content: `${this.$t('error')}`,
          color: "error"
        });
      }
    },
    async showDetail(auditLog) {
      this.tempAuditLog = auditLog
      this.isAuditLogDetailDialog = true
      if (auditLog.type == "update_contract" && (auditLog.newObject.startMeterData || auditLog.oldObject.startMeterData)) {
        this.isLoadingDialog = true
        try {
          let meterIds = []
          for (let key in auditLog.newObject.startMeterData) {
            meterIds.push(key)
          }
          for (let key in auditLog.oldObject.startMeterData) {
            meterIds.push(key)
          }
          this.meters = await Meter.getMeterByIds(meterIds)
          this.meters = this.meters.sort((a, b) => a.type - b.type)
          this.isLoadingDialog = false
        } catch (err) {
          this.isLoadingDialog = false
        }
      }
    },
    getProductName(products) {
      if (products) {
        return products.map(d => d.name).join(",")
      } else {
        return ""
      }
    },
    getMeter(meterId) {
      return this.meters.find(d => d.objectId == meterId)
    },
    exportExcel() {
      ExportAuditLog.exportAuditLog(this.auditLogs, this.startDate, this.endDate)
    },
    printPDF() {
      const tempItemsPerPage = this.itemsPerPage
      this.itemsPerPage = -1
      setTimeout(() => {
        let printarea = document.getElementById("printarea").innerHTML;
        let printPreviewTopic = document.getElementById("print-preview-topic");
        let printPreviewcontent = document.getElementById("print-preview-content");
        let printPreviewFooter = document.getElementById("print-preview-footer");

        printPreviewTopic.innerHTML = `
          <h2 style="text-align: center;" class="my-4">
            <b>${this.$t('edit_history')}</b>
          </h2>
          <p style="text-align: center;">${this.market.name}</p>
          <p style="text-align: center;">
            ${this.$moment(this.startDate, "YYYY-MM-DD").format("D MMMM YYYY")} - ${this.$moment(this.endDate, "YYYY-MM-DD").format("D MMMM YYYY")}
          </p>
        `
        printPreviewcontent.innerHTML = printarea
        printPreviewFooter.innerHTML = `<div style="text-align: right;"><b>${this.$t('print_by')} : </b>${this.userFullName} <b>${this.$t('when')} : </b> ${this.$moment().format("lll")}</div>`
        window.print();
        this.itemsPerPage = tempItemsPerPage
      }, 200)

    }
  },
};
</script>
<style lang="scss" scoped>
.text-nowrap-table.customer-name {
  width: 150px;
}
</style>